import React, { useState, useEffect } from 'react'
import { Box, Image, Fade, useBreakpointValue } from '@chakra-ui/react'
import { ArrowForwardIcon, ArrowBackIcon } from '@chakra-ui/icons'

import Fallback from './Fallback'

type Props = {
  images: string[]
  desktopImages?: string[]
  height?: any
  objectPosition?: any
}

const Carousel = ({ images, desktopImages, height = { base: '52vh', md: '42vh' }, objectPosition = { base: 'center top', md: 'center center' } }: Props) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0)
  const [manual, setManual] = useState(false)
  const [dragStartX, setDragStartX] = useState(0)
  const isDesktop = useBreakpointValue({ base: false, md: true })
  const carouselImages = isDesktop && desktopImages?.length ? desktopImages : images
  const activeImageIndex = currentImageIndex % carouselImages.length

  useEffect(() => {
    const intervalId = setInterval(() => {
        if (!manual) {
          setCurrentImageIndex((index) => (index + 1) % carouselImages.length)
        }
    }, 3000)
    return () => clearInterval(intervalId)
  }, [carouselImages.length, manual])

  const handleArrowClick = (direction: 'left' | 'right') => {
    setManual(true)
    if (direction === 'left') {
      setCurrentImageIndex((index) => (index - 1 + carouselImages.length) % carouselImages.length)
    } else {
      setCurrentImageIndex((index) => (index + 1) % carouselImages.length)
    }
  }

  const handleDragStart = (event: React.TouchEvent<HTMLDivElement>) => {
    setDragStartX(event.touches[0].clientX)
  }

  const handleDragEnd = (event: React.TouchEvent<HTMLDivElement>) => {
    const nextDragEndX = event.changedTouches[0].clientX
    if (nextDragEndX - dragStartX > 50) {
      handleArrowClick('left')
    } else if (nextDragEndX - dragStartX < -50) {
      handleArrowClick('right')
    }
  }

  const handleDragMove = (event: React.TouchEvent<HTMLDivElement>) => {
    event.preventDefault()
  }
  

  return (
    <Box 
        w="100%" h={height}
        userSelect="none"
        position="relative"
        onTouchStart={handleDragStart}
        onTouchEnd={handleDragEnd}
        onTouchMove={handleDragMove}
        >
      {carouselImages.map((imageUrl, index) => (
        <Fade key={imageUrl} in={index === activeImageIndex}>
          <Image
            src={imageUrl}
            alt={`Carousel image ${index}`}
            w="100%"
            h={height}
            position="absolute"
            objectFit={'cover'}
            objectPosition={objectPosition}
            top="0"
            left="0"
            draggable={false}
            fallback={<Fallback />}
          />
        </Fade>
      ))}
      <Box
        position="absolute"
        top="50%"
        transform="translateY(-50%)"
        left={{base:"5vw", 'md':"10vw"}}
        zIndex="1"
        cursor="pointer"
        userSelect="none"
        onMouseDown={(event) => event.preventDefault()}
        /*bg={'rgba(255,255,255,0.5)'}
        borderRadius={'50%'}
        backdropFilter={'blur(10px)'}*/
        onClick={() => handleArrowClick('left')}
      >
        <ArrowBackIcon
            margin={'0.5vw'}
            boxSize={8} />
      </Box>
      <Box
        position="absolute"
        top="50%"
        transform="translateY(-50%)"
        right={{base:"5vw", 'md':"10vw"}}
        zIndex="1"
        cursor="pointer"
        userSelect="none"
        onMouseDown={(event) => event.preventDefault()}
        onClick={() => handleArrowClick('right')}
      >
        <ArrowForwardIcon 
            boxSize={8}/>
      </Box>
    </Box>
  )
}

export default Carousel
